import { useTranslations } from "next-intl";
import { TCatOverview, TUseCatOverviewCard } from "./CatOverviewCard.config";
import { useCatBreed } from "@/hooks";
import { getToMonthDate } from "libs/utils/misc/src/dates";

export const useCatOverviewCard = (cat: TCatOverview): TUseCatOverviewCard => {

  const breed = useCatBreed().translate(cat.breed);
  const tVocabulary = useTranslations("Shared.Vocabulary");
  const tCatOverviewCard = useTranslations("CustomerPortal.Sections.Cats.CatCards.CatOverviewCard");

  const tUnknown = tVocabulary("unknown");

  return {
    eatingSince: cat.eatingSince ? tCatOverviewCard("eatingSince", {
      date:getToMonthDate(cat.eatingSince),
    }) : null,
    details: {
      breed: {
        label: tCatOverviewCard("Details.Breed.label"),
        value: breed,
      },
      birthday: {
        label: tCatOverviewCard("Details.Birthday.label"),
        value: cat.birthday ? getToMonthDate(cat.birthday) : tUnknown,
      },
      neutured: {
        label: tCatOverviewCard("Details.Neutered.label"),
        value: tCatOverviewCard("Details.Neutered.value", {
          gender: cat.gender,
          isNeutered: String(cat.neuterStatus),
        }),
      },
    },
    defaultLabels: {
      unknown: tUnknown,
      edit: tVocabulary("edit"),
    },
  };
};
